const timeToDate = function (timestamp) {
    return timestamp;
}

export default {
    timeToDate,
};